import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6 34.5V42h7.5l22.12-22.12-7.5-7.5zm35.42-20.42c.78-.78.78-2.04 0-2.82l-4.68-4.68a1.99 1.99 0 0 0-2.82 0l-3.66 3.66 7.5 7.5z" })
});
export default SvgEdit;
